import React, { useState } from 'react';
import Container from '../container';
import parseStoryblokLink from '../../utils/parseStoryblokLink';
import LazyImage from '../lazy-image';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import styled, { css } from 'styled-components';
import CtaWithArrow from '../cta-with-arrow';
import mq from '../../utils/mq';
import { motion } from 'framer-motion';

const DualLinkCardsOuterContainer = styled.div`
  background-color: #f8f8f8;
  padding-top: 104px;
  padding-bottom: 104px;
  ${mq.mobile(css`
    padding-top: 32px;
    padding-bottom: 32px;
  `)};
`;

const DualLinkCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  ${mq.mobile(css`
    display: flex;
    flex-direction: column;
    gap: 20px;
  `)};
`;

const DualLinkCardItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  text-decoration: none;
  cursor: pointer;
  border-radius: var(--Radius-Radius-3, 16px);
  box-shadow: 0 0 74px 0 rgba(0, 0, 0, 0.15) inset;
`;

const ImageContainer = styled.span`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 16/11;
`;

const TextContent = styled.span`
  background-color: #fff;
  padding: 40px 60px;
  display: block;
  ${mq.mobile(css`
    padding: 32px 24px;
  `)};
`;

const TitleContent = styled.span`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 28px;
`;

const Title = styled.span`
  color: #161616;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -0.48px;
`;

const Description = styled.span`
  color: #666;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.18px;
`;

export default function DualLinkCards({ cards }: { cards: any[] }) {
  return (
    <DualLinkCardsOuterContainer>
      <Container>
        <DualLinkCardsContainer>
          {cards.map((card) => (
            <DualLinkCard key={card.id} card={card} />
          ))}
        </DualLinkCardsContainer>
      </Container>
    </DualLinkCardsOuterContainer>
  );
}

const DualLinkCard = ({ card }: { card: any }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <DualLinkCardItem
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <a
        href={card?.ctaLink ? parseStoryblokLink(card.ctaLink) : '#'}
        style={{
          backgroundColor: '#fff',
          textDecoration: 'none',
          color: 'inherit',
          height: '100%',
          width: '100%'
        }}
      >
        <ImageContainer>
          <motion.div
            style={{
              willChange: 'transform'
            }}
            animate={
              isHovered
                ? {
                    scale: 1.03,
                    transition: { duration: 0.6, ease: [0.26, 1, 0.5, 1] }
                  }
                : {
                    scale: 1,
                    transition: { duration: 0.3, ease: [0.26, 1, 0.5, 1] }
                  }
            }
          >
            <LazyImage fluid={getFluidGatsbyImage(card.image)} />
          </motion.div>
        </ImageContainer>
        <TextContent>
          <TitleContent>
            <Title>{card.title}</Title>
            <Description>{card.description}</Description>
          </TitleContent>
          <CtaWithArrow
            link={card?.ctaLink ? parseStoryblokLink(card.ctaLink) : '#'}
            label={card.ctaLabel}
            isHovered={isHovered}
          />
        </TextContent>
      </a>
    </DualLinkCardItem>
  );
};
